import React from 'react';

import Lightbox, { type SlideImage } from 'yet-another-react-lightbox';
import type { BrainAtlasType, MultiLang } from '../../../../config';
import Functions from '../../../../functions';
import ItemUtil, { type ItemBasicFile } from '../../../lib/ItemUtil';

import 'yet-another-react-lightbox/styles.css';
import styles from './Preview.module.css';

interface Props {
    lang: MultiLang;
    file: ItemBasicFile[];
    type: BrainAtlasType;
}

const Preview: React.FC<Props> = (props) => {
    const { lang, file, type } = props;

    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    const [imageIndex, setImageIndex] = React.useState<number>(0);

    const data = file.filter((value) => {
        return value.file_type_name === 'preview';
    });
    if (data.length === 0) {
        return null;
    }
    const slides: SlideImage[] = [];

    const previews = data.map((value, idx) => {
        const fileUrl = ItemUtil.getFileUrl(type, value);
        const previewUrl = ItemUtil.getPreviewFileUrl(type, value);
        const caption = Functions.mlang(value.caption, lang);
        slides.push({ src: fileUrl });
        return (
            <figure key={value.file_id} className={styles.preview}>
                <a
                    href={fileUrl}
                    download={value.original_file_name}
                    onClick={(e) => {
                        e.preventDefault();
                        setIsOpen(true);
                        setImageIndex(idx);
                    }}
                >
                    <img src={previewUrl} alt={caption} />
                </a>
                <figcaption>{caption}</figcaption>
            </figure>
        );
    });

    return (
        <>
            <div className={styles.previewBox}>{previews}</div>
            {isOpen && <Lightbox index={imageIndex} slides={slides} close={() => setIsOpen(false)} />}
        </>
    );
};

export default Preview;
